/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ResponseB4AListOrderMovementStatusDescription {
  result?: Array<ResponseB4AListOrderMovementStatusDescription.ResultEnum>;
}
export namespace ResponseB4AListOrderMovementStatusDescription {
  export type ResultEnum =
    | 'EMPTY'
    | 'AG_APROVACAO'
    | 'AG_ASSINATURA'
    | 'AG_ESTOQUE'
    | 'AG_RESSUPRIMENTO'
    | 'AG_LIBERAR_EDICOES'
    | 'AG_FATURAMENTO';
  export const ResultEnum = {
    EMPTY: 'EMPTY' as ResultEnum,
    AGAPROVACAO: 'AG_APROVACAO' as ResultEnum,
    AGASSINATURA: 'AG_ASSINATURA' as ResultEnum,
    AGESTOQUE: 'AG_ESTOQUE' as ResultEnum,
    AGRESSUPRIMENTO: 'AG_RESSUPRIMENTO' as ResultEnum,
    AGLIBERAREDICOES: 'AG_LIBERAR_EDICOES' as ResultEnum,
    AGFATURAMENTO: 'AG_FATURAMENTO' as ResultEnum
  };
}
